import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/machines',
    name: 'AdminMachines',
    component: {
      name: 'AdminMachines',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'machine',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminMachineIndex',
        component: () => import('../views/MachineIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminMachineNew',
        component: () => import('../views/MachineInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminMachineIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminMachineShow',
        component: () => import('../views/MachineShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminMachineIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminMachineDetails',
            component: () => import('../views/MachineDetails.vue'),
            meta: {
              backRoute: { name: 'AdminMachineIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminMachineEdit',
            component: () => import('../views/MachineInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminMachineDetails' },
            },
          },
          {
            path: 'certificates',
            name: 'AdminMachineCertificates',
            component: () => import('../views/certificate/MachineCertificates.vue'),
            meta: {
              backRoute: { name: 'AdminMachineIndex' },
              resource: 'certificate',
            },
          },
          {
            path: 'reparations',
            name: 'AdminMachineReparations',
            component: () => import('../views/reparation/MachineReparations.vue'),
            meta: {
              backRoute: { name: 'AdminMachineIndex' },
              resource: 'reparation',
            },
          },
          {
            path: 'planning_assignments',
            name: 'AdminMachinePlanningAssignments',
            component: () => import('../views/planningAssignment/MachinePlanningAssignments.vue'),
            meta: {
              backRoute: { name: 'AdminMachineIndex' },
              resource: 'planning_assignment',
            },
          },
        ],
      },
    ],
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));